
document.addEventListener( 'DOMContentLoaded', function () {
  var main = new Splide( '#primary_slider', {
    type      : 'slide',
    rewind    : true,
    pagination: false,
    arrows    : true,
  } );


  var thumbnails = new Splide( '#thumbnail_slider', {
    gap         : 10,
    perPage: 3,
     arrows    : false,
    rewind      : true,
    pagination  : false,
    cover       : true,
    isNavigation: true,
      breakpoints : {
      989: {
         perPage     : 3,
      },
       749: {
         perPage     : 2,
      },
    },
  } );


  main.sync( thumbnails );
  main.mount();
  thumbnails.mount();
} );





document.addEventListener( 'DOMContentLoaded', function () {
  var main = new Splide( '#primary__slider', {
    type      : 'slide',
    rewind    : true,
    pagination: false,
    arrows    : true,
  });
  var thumbnails = new Splide( '#tab_with_icon_slider', {
    gap         : 10,
    perPage     : 5,
    arrows     : false,
    rewind      : true,
    pagination  : false,
    cover       : true,
    isNavigation: true,
    breakpoints : {
      989: {
         perPage     : 3,
      },
       749: {
         perPage     : 2,
      },
    },
  });
  main.sync( thumbnails );
  main.mount();
  thumbnails.mount();
} );